import React from 'react';

const Card = ( {details} ) => {
    const requireImage = chemin => {
        if("" !== chemin){
            return chemin
        }else{
            return require(`../img/default.png`)
        }
    }
    return (
        <div className="card">
            <div className="image">
                <img src={requireImage(details.base64)} alt={details.nom} />
            </div>
            <div className="nom-article">
                <h1>{details.nom}</h1>
                <div className="preambule">
                <h3>{ details.preambule }</h3>
                </div>
                <div className="texte-article">
                    { details.texte }
                </div>
            </div>
        </div>
    );
};

export default Card;